/**
 * LE THÈME. Parchemin par défaut, veillée pour qui joue la lampe éteinte (design §1.2).
 *
 * Le choix est écrit dans `localStorage` et relu par six lignes dans `index.html`, AVANT la
 * première peinture : sans elles, un joueur en veillée prend un éclair de parchemin blanc à chaque
 * chargement — exactement ce qu'il avait choisi d'éviter.
 */
import { useCallback, useSyncExternalStore } from "react";

export type Theme = "parchemin" | "veillee";

const CLEF = "destinia.theme";
const CHANGEMENT = "destinia:theme";

function actuel(): Theme {
  return document.documentElement.dataset.theme === "veillee" ? "veillee" : "parchemin";
}

export function useTheme(): [Theme, () => void] {
  const theme = useSyncExternalStore(
    (rappel) => {
      window.addEventListener(CHANGEMENT, rappel);
      return () => window.removeEventListener(CHANGEMENT, rappel);
    },
    actuel,
    () => "parchemin" as Theme
  );

  const bascule = useCallback(() => {
    const suivant: Theme = actuel() === "veillee" ? "parchemin" : "veillee";
    document.documentElement.dataset.theme = suivant;
    try {
      localStorage.setItem(CLEF, suivant);
    } catch {
      /* stockage refusé : le thème vivra le temps de la session, et c'est tout */
    }
    window.dispatchEvent(new Event(CHANGEMENT));
  }, []);

  return [theme, bascule];
}
